import { Button } from '@mui/material'
import { ReactElement, useState } from 'react'

import { RepairOrderExpanded } from '../../sdk'
import { LoadingWrapper } from '../SharedUI/LoadingWrapper'
import { CustomerAuthorizationDialog } from './CustomerAuthorizationDialog'

interface Props {
  previousTotal: number | undefined
  repairOrder: RepairOrderExpanded | undefined
  shopName: string
}

const AuthorizeServicesButton: ({
  previousTotal,
  repairOrder,
  shopName
}: Props) => ReactElement = ({ previousTotal, repairOrder, shopName }) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const [isLoading, setLoading] = useState(false)

  const handleClose = () => setDialogOpen(false)

  return (
    <>
      <LoadingWrapper loading={isLoading}>
        <CustomerAuthorizationDialog
          dialogOpen={dialogOpen}
          handleClose={handleClose}
          previousTotal={previousTotal}
          repairOrder={repairOrder}
          shopName={shopName}
          setLoading={setLoading}
        />
      </LoadingWrapper>
      <Button
        variant="contained"
        color="success"
        onClick={() => setDialogOpen(true)}>
        Authorize Services
      </Button>
    </>
  )
}

export default AuthorizeServicesButton
